import { render, staticRenderFns } from "./body-row.vue?vue&type=template&id=088bbb80&scoped=true"
import script from "./body-row.vue?vue&type=script&lang=js"
export * from "./body-row.vue?vue&type=script&lang=js"
import style0 from "./body-row.vue?vue&type=style&index=0&id=088bbb80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088bbb80",
  null
  
)

export default component.exports